// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__Jus2X","colCheckbox":"styles_colCheckbox__2vS78"};